import { useCallback, useMemo } from "react";

import { customFilterTypes } from "shared/constants/allocationsEnums";
import { useApi } from "shared/services/api/useApi";

export const useCustomFilters = () => {
    const { getDataAsync, postData, patchData, deleteData } = useApi();

    const getCustomFilter = useCallback(async () => {
        const payload = await getDataAsync("getCustomFilter", { params: { typeId: customFilterTypes.ALLOCATION } });
        return payload.json();
    }, [getDataAsync]);

    const createCustomFilter = useCallback(async (body) => {
        const payload = await postData("createCustomFilter", { body: body });
        return payload.json();
    }, [postData]);

    const updateCustomFilter = useCallback(async (body) => {
        return patchData("updateCustomFilter", { body: body });
    }, [patchData]);

    const deleteCustomFilter = useCallback(async (urlParams) => {
        return deleteData("deleteCustomFilter", { urlParams: urlParams });
    }, [deleteData]);

    return useMemo(() => {
        return {
            getCustomFilter,
            createCustomFilter,
            updateCustomFilter,
            deleteCustomFilter,
        };
    }, [getCustomFilter, createCustomFilter, updateCustomFilter, deleteCustomFilter]);
};
